import React from 'react'
import { ENDPOINT } from '../../services/endPoints';
import CustomDataTable from '../../components/CustomDataTable/CustomDataTable';
import { useOutlet } from 'react-router-dom';

const HospitalReferredTest = () => {
  const outlet = useOutlet();
  const hospitalId = localStorage.getItem("hospitalId");
    const excludedKeys = ["hospital_id"];

    const compareValue = [ "hospital_id", "hospital_name", "total_referred_tests", "test_viewed", "rejected_tests", "pending_tests" ];

    const customKeyName = {
      hospital_id: "Referred Facility ID",
      hospital_name: "Referred Facility Name",
      total_referred_tests: "Total Referred Tests",
      test_viewed: "Viewed",
      rejected_tests: "Rejected",
      pending_tests: "Pending"
    };

    // const customWidth = {
    //   Hospital_ID: "180px",
    //   Hospital_Name: "120px",
    //   Total_Referred_Tests: "200px",
    //   Test_Viewed: "150px",
    //   Rejected_Tests: "200px",
    // };

  return (
     outlet || (
    <>
    <CustomDataTable 
                tableTitle={"List of Referred Test"}
                endPoint={ENDPOINT.DASHBOARD_REFERREDTEST}
                filterKey={"hospital_name"}
                excludedKeys={excludedKeys}
                customKeyName={customKeyName}
                compareValue={compareValue}
                // customWidth={customWidth}
                />
    </>
     )
 )
}

export default HospitalReferredTest